import { useEffect, useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import redux, { api } from '../redux'
import { handleGetErrors } from '../redux/error/actions'

// {
//   project: { ... },
//   contact: { ... },
//   me: { ... },
//   me_contact: { ... },
//   selectedPersonRole: { person_id: 4, person_name: 'Basses Anställda', ... }
// }

// { query: [{ key: 'id', op: '=', value: id }] }
export function useGetQuery (type, params, autoFetch = true) {
  const dispatch = useDispatch()
  const { siteitem } = redux.actions
  const [status, setStatus] = useState(undefined)
  const [data, setData] = useState(null)

  // console.log('useGetQuery', type, params, autoFetch)

  const effects = useCallback((params) => {
    setStatus('pending')
    if (type === 'project') {
      api.getProjects({ query: params }).then(result => {
        if (result.data.value && result.data.value.length > 0) {
          setData(result.data.value[0])
          dispatch(siteitem.setSiteItem(result.data.value[0]))
        }
        setStatus('fulfilled')
      }).catch((e) => {
        handleGetErrors('project', dispatch)
        setStatus('rejected')
      })
    } else if (type === 'contact') {
      api.getContacts({ query: params }).then(result => {
        if (result.data.value && result.data.value.length > 0) {
          setData(result.data.value[0])
          dispatch(siteitem.setSiteItem(result.data.value[0]))
        }
        setStatus('fulfilled')
      }).catch(() => {
        handleGetErrors('project', dispatch)
        setStatus('rejected')
      })
    } else if (type === 'contact-person') {
      api.getContactPersons({ query: params }).then(result => {
        if (result.data.value && result.data.value.length > 0) {
          setData(result.data.value)
        }
        setStatus('fulfilled')
      }).catch(() => {
        handleGetErrors('contact-person', dispatch)
        setStatus('rejected')
      })
    } else if (type === 'content-type') {
      api.getContentTypes({ query: params }).then(result => {
        if (result.data.value && result.data.value.length > 0) {
          setData(result.data.value)
        }
        setStatus('fulfilled')
      }).catch(() => {
        handleGetErrors('content-type', dispatch)
        setStatus('rejected')
      })
    }
  }, [dispatch, setData, setStatus])

  useEffect(() => {
    if (type && params && autoFetch === true && status === undefined) {
      effects(params)
    }
  }, [effects, params, status, autoFetch])

  const refetch = useCallback((params) => {
    effects(params)
  }, [effects])

  const isLoading = status === 'pending'
  const isError = status === 'rejected'
  const isSuccessful = status === 'fulfilled'
  const isUnitialized = status === undefined
  return { isUnitialized, isError, isSuccessful, data, refetch, isLoading }
}
